import { action } from 'satcheljs';
import type { FlexibleWorkingHoursView, FlexibleWorkingHours } from 'owa-graph-schema';

export interface FwhUpdatedLocalNotifyActionActionMessage {
    segment: FlexibleWorkingHoursView | FlexibleWorkingHours;
    fwh: FlexibleWorkingHoursView[] | FlexibleWorkingHours[];
    buildingId: string | undefined;
}
export const fwhUpdatedLocalNotifyAction: (
    segment: FlexibleWorkingHoursView | FlexibleWorkingHours,
    fwh: FlexibleWorkingHoursView[] | FlexibleWorkingHours[],
    buildingId: string | undefined
) => FwhUpdatedLocalNotifyActionActionMessage = action(
    'fwhUpdatedLocalNotifyAction',
    (
        segment: FlexibleWorkingHoursView | FlexibleWorkingHours,
        fwh: FlexibleWorkingHoursView[] | FlexibleWorkingHours[],
        buildingId: string | undefined
    ): FwhUpdatedLocalNotifyActionActionMessage => ({
        segment,
        fwh,
        buildingId,
    })
);
